// extracted by mini-css-extract-plugin
export default {"container":"Crosshair_container__E5xf5"};